var map = {
	"./android-icon.svg": 2181,
	"./app-img.png": 2182,
	"./app-qr-code-bg.png": 2183,
	"./apple-icon.svg": 2184,
	"./contact-bg.png": 2185,
	"./contact-us-bg.jpg": 2186,
	"./contact-us-main-bg.webp": 2187,
	"./qr-bg.png": 2188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2180;